import { Icon } from "../display/Icon.js";
import { IData, VOCollection, VOConfig, VOExhibition } from "./DataStructure.js";

export interface DataOptions {
    assetsUrl: string;
    url: string;
    progressHandler?: (p: e5.LoaderProgress) => void;
}

export class Data {

    public data: IData;
    public config: VOConfig;

    private _options: DataOptions;

    constructor(options: DataOptions) {
        this._options = e5.object.merge({

        }, options);
    }

    public async load(): Promise<IData> {
        const data: IData = await e5.load("json",
            this._options.url, {
            onProgress: this._options.progressHandler
        });

        const configTitle = e5.Url.params.get("config", "Default");
        this.config = data.focke_config?.find((v) => {
            return configTitle.toLocaleLowerCase() === v.title.toLocaleLowerCase();
        });
        if (!this.config) {
            let message = `Konfiguration mit dem Titel "${configTitle}" nicht vorhanden.`;
            if (data.focke_config.length > 0) {
                message += `<br><br>Folgende Konfigurationen sind vorhanden:<br><div>${data.focke_config.map(
                    (c) => `<div><a href="${e5.Url.params.set("config", c.title)}">${c.title}</a></div>`).join("")}`;
            }
            console.warn(message);
            throw new Error(message);
        }

        for (let config of data.focke_config) {
            if (config.collection) {
                config.collection = e5.array.id(data.focke_collection, config.collection as any);
            }
        }

        if (!this.config.collection) {
            let message = `Bitte wählen Sie für die Konfiguration "${this.config.title}" eine Zusammenstellung aus.`;
            console.warn(message);
            throw new Error(message);
        }

        const previewImageFallback = this._options.assetsUrl + "/preview-fallback.svg";
        for (let e of data.focke_exhibition) {

            if (!e.medias) {
                e.medias = [];
            }
            for (let m of e.medias) {
                m.exhibition = e;

                let preview: string = "";
                if (m.preview?.sizes?.large) {
                    preview = m.preview.sizes.large;
                } else if (m.type === "image"
                    && m.image?.sizes?.large) {
                    preview = m.image.sizes.large;
                } else if (m.type === "video"
                    && m.video?.sizes?.large) {
                    preview = m.video.sizes.large;
                } else if (m.type === "gallery"
                    && m.gallery[0]?.image?.sizes?.large) {
                    preview = m.gallery[0].image.sizes.large;
                } else {
                    preview = previewImageFallback;
                }
                m.preview_image_url = preview;

                let icon = "none";
                if (m.type === "video") {
                    icon = Icon.MEDIA_TYPE_VIDEO;
                }
                else if (m.type === "image") {
                    icon = Icon.MEDIA_TYPE_IMAGE;
                }
                else if (m.type === "gallery") {
                    icon = Icon.MEDIA_TYPE_GALLERY;
                }
                else if (m.type === "iframe") {
                    icon = Icon.MEDIA_TYPE_IFRAME;
                }
                m.icon = icon;
            }

            e.preview_image_url = e.preview?.sizes?.large || e.medias[0]?.preview_image_url || previewImageFallback;
        }

        for (let c of data.focke_collection) {
            let exhibitions: VOExhibition[] = [];
            if (c.exhibitions) {
                for (let id of c.exhibitions) {
                    let e = e5.array.id(data.focke_exhibition, id as any);
                    if (e) {
                        exhibitions.push(e);
                    }
                }
            }
            c.exhibitions = exhibitions;
        }

        if (!this.config.collection.exhibitions
            || this.config.collection.exhibitions.length === 0) {
            let message = `Bitte wählen Sie für die Zusammenstellung "${this.config.collection.title}" mindestens eine Ausstellung aus.`;
            console.warn(message);
            throw new Error(message);
        }


        this.data = data;

        return data;
    }
}